export * from './base-apollo.response';
